import { FILE_SIZE } from '@shared/constants/fileSize';
import { FILE_TYPES } from '@shared/constants/fileTypes';
import FileValidator from '@shared/validators/FileValidator';
import Joi from 'joi';

const MAX_FILE_SIZE = 50 * FILE_SIZE.MB;

const LEGAL_DOCUMENT_SCHEMA = Joi.object({
  completedDate: Joi.date().required(),
  orgUnitIds: Joi.array().items(Joi.number()).min(1).required(),
  file: Joi.object().required()
}).unknown();

const LegalDocumentValidator = {
  addSchema: LEGAL_DOCUMENT_SCHEMA,
  fileSchema: FileValidator.createFileSchema([FILE_TYPES.PDF], MAX_FILE_SIZE)
};

export default LegalDocumentValidator;
